// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 167) return "static/chunks/167-56e9e6383e807a1a.js";
	if (chunkId === 850) return "static/chunks/850-9c2beb6ab4574ab7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"115":"5816e58660be7fee","263":"fc6c08cb220c21ed","635":"1fff0ca81efc544d","793":"42ef63b7ec463244"}[chunkId] + ".js";
};